import { render, staticRenderFns } from "./StartNavigation.vue?vue&type=template&id=5e6aed3a&scoped=true&"
import script from "./StartNavigation.vue?vue&type=script&lang=ts&"
export * from "./StartNavigation.vue?vue&type=script&lang=ts&"
import style0 from "./StartNavigation.vue?vue&type=style&index=0&id=5e6aed3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e6aed3a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VApp,VBtn,VCol,VIcon,VLayout,VRow})
